import { render, staticRenderFns } from "./ResultListGuanfang.vue?vue&type=template&id=71e2db5a&scoped=true&"
import script from "./ResultListGuanfang.vue?vue&type=script&lang=js&"
export * from "./ResultListGuanfang.vue?vue&type=script&lang=js&"
import style0 from "./ResultListGuanfang.vue?vue&type=style&index=0&id=71e2db5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2db5a",
  null
  
)

export default component.exports